export default "__VITE_ASSET__DXYG6ZVA__"